export const TREE_EVENTS = {
    onToggle: 'onToggle',
    onToggleExpanded: 'onToggleExpanded',
    onActiveChanged: 'onActiveChanged',
    onActivate: 'onActivate',
    onDeactivate: 'onDeactivate',
    onFocus: 'onFocus',
    onBlur: 'onBlur',
    onRightClick: 'onRightClick',
    onInit: 'onInit',
    onDoubleClick: 'onDoubleClick',
    onSearchComplete: 'onSearchComplete',
    onUpdate: 'onUpdate',
    onLoadChildren: 'onLoadChildren'
};



// WEBPACK FOOTER //
// ./src/common/tree/constants/events.ts